/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/*       */

import React from 'react';
import debounce from 'lodash/debounce';
import styled, { ThemeProvider, css } from 'styled-components';

import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import pxInRem from 'shared/helpers/styled-components/remHelper';
import { COLORS } from 'shared/constants/theme';
import theme from '../theme';
import Now from './../containers/TvGuideNowContainer';
import Tonight from './../containers/TvGuideTonightContainer';
import Week from './../containers/TvGuideWeekContainer';

const Wrapper = styled.section`
  ${props =>
    ['now', 'tonight'].includes(props.type) &&
    css`
      margin-top: 0 !important;
    `} ${props =>
    props.type === 'week' &&
    css`
      margin-top: 15px !important;

      ${mediaQueries.toTablet`
      margin: 0 !important;
    `};
    `} .slick-next,
    .slick-prev {
    z-index: 2;
    top: 0;
    width: ${pxInRem(40)};
    height: ${pxInRem(40)};

    // Hide built-in arrow
    &:before {
      content: '';
    }
  }

  .slick-prev {
    left: 0;
    transform: rotate(90deg);
  }

  .slick-next {
    right: 0;
    transform: rotate(-90deg);
  }

  .Arrow--default {
    &.slick-next,
    &.slick-prev {
      color: ${COLORS.black};
    }

    &.slick-disabled {
      opacity: 0.5;
    }
  }

  .Arrow--light {
    &.slick-next,
    &.slick-prev {
      color: ${COLORS.white};
      background-color: ${COLORS.black};
    }

    &.slick-disabled {
      color: ${COLORS.black};
      background-color: ${COLORS.black};
    }
  }
`;

const Components = {
  now: Now,
  tonight: Tonight,
  week: Week
};

export default class TvGuide extends React.PureComponent {
  displayName = 'TvGuide';

  /**
   * Calculate & Save scroll offset to top
   */
  onWindowScroll = debounce(() => {
    const y = window.pageYOffset || document.documentElement.scrollTop;
    this.props.saveScrollPosition({ x: 0, y });
  }, 300);

  /**
   * Add event listener
   */
  componentDidMount() {
    // Restore Scroll position
    const { scrollTo, scrollPosition } = this.props;
    if (scrollPosition) {
      scrollTo(scrollPosition.y, scrollPosition.x);
    }

    this.onWindowScroll();
    window.addEventListener('scroll', this.onWindowScroll);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  render() {
    const { type, ...rest } = this.props;

    return (
      <Wrapper type={type}>
        <ThemeProvider theme={theme}>
          {React.createElement(Components[type], rest)}
        </ThemeProvider>
      </Wrapper>
    );
  }
}
